import { jsxs as l, jsx as a } from "react/jsx-runtime";
import { memo as T, useState as y, useRef as c, useCallback as i } from "react";
import { Snackbar as w, AlertTitle as S } from "@mui/material";
import { isNotNil as d } from "./types3.mjs";
import { ToastManagerContext as A } from "./ToastManagerContext.mjs";
import { Typography as p } from "./index59.mjs";
import { Alert as O } from "./styles29.mjs";
const m = {
  autoHideDuration: 6e3,
  anchorOrigin: { horizontal: "right", vertical: "top" }
}, H = T(({ children: u }) => {
  const [o, s] = y(null), h = c(null), e = i((t, r) => {
    s({ message: t, variant: "success", ...r });
  }, []), n = i(() => {
    s(null);
  }, []), g = i(
    (t, r) => {
      e(t, { variant: "success", ...r });
    },
    [e]
  ), v = i(
    (t, r) => {
      e(t, { variant: "error", ...r });
    },
    [e]
  ), f = i(
    (t, r) => {
      e(t, { variant: "info", ...r });
    },
    [e]
  ), x = i(
    (t, r) => {
      e(t, { variant: "warning", ...r });
    },
    [e]
  ), C = c({
    showSuccess: g,
    showError: v,
    showInfo: f,
    showWarning: x,
    close: n
  });
  return /* @__PURE__ */ l(A.Provider, { value: { api: C }, children: [
    u,
    d(o) && /* @__PURE__ */ a(
      w,
      {
        open: d(o),
        onClose: n,
        autoHideDuration: m.autoHideDuration,
        anchorOrigin: m.anchorOrigin,
        "data-testid": o.testId,
        children: /* @__PURE__ */ l(
          O,
          {
            severity: o.variant,
            onClose: o.isCloseable ? n : void 0,
            slotProps: {
              closeButton: {
                sx: (t) => ({
                  padding: t.tokens.spacing[4]
                })
              },
              closeIcon: {
                sx: (t) => ({
                  color: t.palette.action.active
                })
              }
            },
            variant: "filled",
            children: [
              o.title && /* @__PURE__ */ a(S, { children: /* @__PURE__ */ a(
                p.TextSm.SemiBold,
                {
                  sx: (t) => ({ color: t.palette.text.primary }),
                  children: o.title
                }
              ) }),
              /* @__PURE__ */ a(
                p.Body2,
                {
                  sx: (t) => ({
                    color: o.title ? t.palette.text.secondary : t.palette.text.primary,
                    paddingRight: o.isCloseable ? 0 : 1
                  }),
                  children: o.message
                }
              ),
              o.actions
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ a("div", { ref: h })
  ] });
});
export {
  H as ToastManager
};
//# sourceMappingURL=ToastManager.mjs.map
